import { ReusableModal } from "ui/molecules/modal/ReusableModal";
import { View } from "ui/atoms/view";
import { Button } from "ui/gluestack/button";
import { Text } from "react-native";
import { StatusFlagModel } from "app/services/api/types/statusFlags/models/StatusFlagModel";
import { useHandleDeleteFlag } from "../hooks/useHandleDeleteFlag";

export interface Props {
  isVisible: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  flag?: StatusFlagModel;
}

export function DeleteFlagModal({
  isVisible,
  onClose,
  onSuccess,
  flag,
}: Props) {
  const { isDeleting, handleDeleteFlag } = useHandleDeleteFlag(onSuccess);
  const handleDelete = () => {
    if (!flag?.id) return;
    handleDeleteFlag({ id: flag.id });
  };
  return (
    <ReusableModal
      isVisible={isVisible}
      onClose={onClose}
      className="w-full max-w-[378px] mx-auto"
      title="Are you sure you want to delete this status flag?"
      description="This action will remove this status flag permanently and cannot be undone. Please confirm if you want to proceed."
      hasCancelButton
    >
      <View className="flex flex-row justify-end gap-x-4 ">
        <Button action="primary" size="sm" variant="outline" onPress={onClose}>
          <Text className="text-primary-500 font-semibold">Cancel</Text>
        </Button>
        <Button
          action="negative"
          size="sm"
          disabled={isDeleting}
          onPress={handleDelete}
        >
          <Text className="text-white">Delete</Text>
        </Button>
      </View>
    </ReusableModal>
  );
}
